import styled from 'styled-components';

const processData = [
  {
    title: '경매신청',
    sub: '채권자 > 법원',
    desc: '경매신청 비용예납',
  },
  {
    title: '경매개시결정(임의/강제)',
    sub: '법원',
    desc: `경매개시 결정에 대한 이의\n(받아들여지면 절차 집행정지의 효력)\n경매신청 등기 촉탁, 개시 결정문 송달`,
  },
  {
    title: '경매 준비절차 진행',
    sub: '법원 > 집행관 감정인',
    desc: '집행관: 현황조사명령, 평가명령\n감정인: 평가명령\n관청에 최고',
  },
  {
    title: '배당요구종기일 지정',
    sub: '법원 > 이해관계인',
    desc: '이해관계인: 권리신고(임차인 배당요구/철회)',
  },
  {
    title: '경매(매각)기일 지정 공고',
    sub: '법원',
    desc: '법원게시판 공고(매각기일 14일 전)',
  },
  {
    title: '입찰(매각) 실시',
    sub: '매수인 > 법원',
  },
  {
    title: '입찰(매각) 마감 및 개찰',
    sub: '매수인',
    desc: '최고가매수신고인,\n차순위매수신고인 선정',
    desc2: '최저매각가격 미달 혹은 입찰자가 없을 시 유찰',
    desc2_sub: '법원',
  },
  {
    title: '낙찰(매각) 허가 결정',
    sub: '법원',
    desc: '절차상 흠결사항 발견 시 낙찰 불허가',
  },
  {
    title: '낙찰(매각) 허가 확정',
    sub: '법원',
    desc2: '허가결정 1주일 이내 즉시항고 가능\n낙찰(매각)대금의 10분의 1 공탁',
    desc2_sub: '이해관계인 > 법원',
  },
  {
    title: '낙찰대금 지급기한 결정',
    sub: '법원',
  },
  {
    title: '낙찰대금 납부',
    sub: '최고가매수신고인',
    desc: '30일 이내',
  },
  {
    title: '소유권등기 촉탁,부동산 인도명령',
    sub: '매수인 > 법원',
    desc: '법원: 관할기소에 소유권 이전 등기\n매수인: 점유자 상대로 법원에 부동산 인도명령 신청 가능',
  },
  {
    title: '배당표 작성',
    sub: '법원',
  },
  {
    title: '매각대금 지급, 배당',
    sub: '법원 > 이해관계인',
    desc: '매각대금 납부 이후 4주 이내\n배당요구한 이해관계인과 채권자',
  },
  {
    title: '예납금 잔액 반환',
    sub: '법원 > 채권자',
    desc: '경매 신청한 채권자에게 예납금 잔액 있을 시 반환',
  },
  {
    title: '기록송부 (보존계), 종료',
    sub: '법원',
  },
];

function AuctionProcess() {
  return (
    <Container>
      {processData.map((step, idx) => (
        <StepWrapper key={idx}>
          {step.desc2 && (
            <DescriptionBox>
              {step.desc2}
              <Sub>{step.desc2_sub}</Sub>
            </DescriptionBox>
          )}
          <Step>
            <Header>
              {step.title}
              <Sub>{step.sub}</Sub>
            </Header>
            {step.desc && <Description>{step.desc}</Description>}
          </Step>
        </StepWrapper>
      ))}
    </Container>
  );
}

export default AuctionProcess;

const Container = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 24px;
  align-items: center;
  padding: 24px 16px;
`;

const StepWrapper = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 24px;
`;

const Step = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  border-radius: 16px;
  border: 1px solid #e1e2e4;
`;

const Header = styled.div`
  display: flex;
  flex-direction: column;
  padding: 16px;
  gap: 4px;

  font-weight: 700;
  font-size: 16px;
`;

const Sub = styled.div`
  font-weight: 500;
  font-size: 14px;
  color: #616161;
`;

const Description = styled.div`
  padding: 16px;
  background-color: #70737c14;

  font-weight: 500;
  font-size: 14px;
  white-space: pre-wrap;
`;

const DescriptionBox = styled.div`
  display: flex;
  flex-direction: column;
  padding: 16px;
  gap: 4px;
  border-radius: 16px;
  background-color: #70737c14;
  font-weight: 500;
  font-size: 14px;
  white-space: pre-wrap;
`;
